import React from 'react';
import './LaoDong.css';

function LaoDong () {
   
        return (
  <div className="lao-dong-page">

        {/* <!-- breadcrumb --> */}
        <div className="lao-dong-breadcrumb">
            <span className="lao-dong-breadcrumb-home">Trang chủ</span>
            <span className="lao-dong-breadcrumb-dot"><i className="fa-solid fa-angle-right"></i></span>
            <span className="lao-dong-breadcrumb-current">Lao động</span>
        </div>
{/* 
        <!-- title --> */}
        <h1 className="lao-dong-page-title">
            Lao động
        </h1>
{/* 
        <!-- thống kê top --> */}
        <div className="lao-dong-top-statistics">

            <div className="lao-dong-top-statistics-card">
                <div className="lao-dong-top-statistics-icon lao-dong-top-statistics-icon-purple">
                    <i className="fa-solid fa-users"></i>
                </div>

                <div className="lao-dong-top-statistics-content">
                    <p className="lao-dong-top-statistics-label">
                        Tổng lao động trong KCN
                    </p>

                    <h3 className="lao-dong-top-statistics-number">
                        52.684
                    </h3>

                    <p className="lao-dong-top-statistics-growth">
                       <i className="fa-solid fa-arrow-up icon-lao-dong-share"></i>
                        <span>2,45% so với tháng trước</span>
                    </p>

                    <button
                        className="lao-dong-top-statistics-button"
                        type="button"
                    >
                        Xem chi tiết →
                    </button>
                </div>
            </div>

            <div className="lao-dong-top-statistics-card">
                <div className="lao-dong-top-statistics-icon lao-dong-top-statistics-icon-green">
                    <i className="fa-solid fa-user-check"></i>
                </div>

                <div className="lao-dong-top-statistics-content">
                    <p className="lao-dong-top-statistics-label">
                        Lao động đang làm việc
                    </p>

                    <h3 className="lao-dong-top-statistics-number">
                        48.761
                    </h3>

                    <p className="lao-dong-top-statistics-growth">
                        <i className="fa-solid fa-arrow-up icon-lao-dong-share"></i>
                       <span> 2,18% so với tháng trước</span>
                    </p>

                    <button
                        className="lao-dong-top-statistics-button"
                        type="button"
                    >
                        Xem chi tiết <i className="fa-solid fa-arrow-right icon-next-detail"></i>
                    </button>
                </div>
            </div>

            <div className="lao-dong-top-statistics-card">
                <div className="lao-dong-top-statistics-icon lao-dong-top-statistics-icon-yellow">
                    <i className="fa-solid fa-user-plus"></i>
                </div>

                <div className="lao-dong-top-statistics-content">
                    <p className="lao-dong-top-statistics-label">
                        Lao động tuyển mới
                    </p>

                    <h3 className="lao-dong-top-statistics-number">
                        1.286
                    </h3>

                    <p className="lao-dong-top-statistics-growth">
                        <i className="fa-solid fa-arrow-up icon-lao-dong-share"></i>
                        <span>3,84% so với tháng trước</span>
                    </p>

                    <button
                        className="lao-dong-top-statistics-button"
                        type="button"
                    >
                        Xem chi tiết <i className="fa-solid fa-arrow-right icon-next-detail"></i>
                    </button>
                </div>
            </div>

            <div className="lao-dong-top-statistics-card">
                <div className="lao-dong-top-statistics-icon lao-dong-top-statistics-icon-red">
                    <i className="fa-solid fa-user-xmark"></i>
                </div>

                <div className="lao-dong-top-statistics-content">
                    <p className="lao-dong-top-statistics-label">
                        Lao động nghỉ việc
                    </p>

                    <h3 className="lao-dong-top-statistics-number">
                        903
                    </h3>

                    <p className="lao-dong-top-statistics-growth">
                        <i class="fa-solid fa-arrow-down icon-lao-dong-share"></i>
                        <span>1,25% so với tháng trước</span>
                    </p>

                    <button
                        className="lao-dong-top-statistics-button"
                        type="button"
                    >
                        Xem chi tiết <i className="fa-solid fa-arrow-right icon-next-detail"></i>
                    </button>
                </div>
            </div>

            <div className="lao-dong-top-statistics-card">
                <div className="lao-dong-top-statistics-icon lao-dong-top-statistics-icon-blue">
                    <i className="fa-solid fa-building"></i>
                </div>

                <div className="lao-dong-top-statistics-content">
                    <p className="lao-dong-top-statistics-label">
                        Doanh nghiệp sử dụng LD
                    </p>

                    <h3 className="lao-dong-top-statistics-number">
                        126
                    </h3>

                    <p className="lao-dong-top-statistics-growth lao-dong-top-statistics-growth-gray">
                        <i className="fa-solid fa-minus icon-minus-ld-share"></i>
                       <span className='no-change'> Không đổi so với tháng trước</span>
                    </p>

                    <button
                        className="lao-dong-top-statistics-button"
                        type="button"
                    >
                        Xem chi tiết <i className="fa-solid fa-arrow-right icon-next-detail"></i>
                    </button>
                </div>
            </div>

        </div>
{/* 
        <!-- biểu đồ --> */}
        <div className="lao-dong-chart-row">

            {/* <!-- biểu đồ 1 --> */}
            <div className="lao-dong-chart-card lao-dong-chart-card-35">

                <div className="lao-dong-chart-header">
                    <h3 className="lao-dong-chart-title">
                        Cơ cấu lao động theo ngành nghề
                    </h3>
                </div>

                <div className="lao-dong-chart-content">

                    <div className="lao-dong-donut-chart">
                        <div className="lao-dong-donut-chart-center">
                            <span className="lao-dong-donut-chart-total-text">
                                Tổng số
                            </span>

                            <h3 className="lao-dong-donut-chart-total-number">
                                48.761
                            </h3>

                            <span className="lao-dong-donut-chart-total-unit">
                                người
                            </span>
                        </div>
                    </div>

                    <div className="lao-dong-chart-legend">
                        <div className="lao-dong-chart-legend-item">
                            <span className="lao-dong-chart-legend-color lao-dong-chart-legend-blue"></span>
                            <span className="lao-dong-chart-legend-name">
                                Sản xuất, chế biến
                            </span>
                            <span className="lao-dong-chart-legend-value">
                                31.452 (64,48%)
                            </span>
                        </div>

                        <div className="lao-dong-chart-legend-item">
                            <span className="lao-dong-chart-legend-color lao-dong-chart-legend-green"></span>
                            <span className="lao-dong-chart-legend-name">
                                Dệt may, da giày
                            </span>
                            <span className="lao-dong-chart-legend-value">
                                7.852 (16,10%)
                            </span>
                        </div>

                        <div className="lao-dong-chart-legend-item">
                            <span className="lao-dong-chart-legend-color lao-dong-chart-legend-yellow"></span>
                            <span className="lao-dong-chart-legend-name">
                                Điện tử, thiết bị điện
                            </span>
                            <span className="lao-dong-chart-legend-value">
                                4.986 (10,23%)
                            </span>
                        </div>

                        <div className="lao-dong-chart-legend-item">
                            <span className="lao-dong-chart-legend-color lao-dong-chart-legend-purple"></span>
                            <span className="lao-dong-chart-legend-name">
                                Cơ khí
                            </span>
                            <span className="lao-dong-chart-legend-value">
                                2.365 (4,85%)
                            </span>
                        </div>

                        <div className="lao-dong-chart-legend-item">
                            <span className="lao-dong-chart-legend-color lao-dong-chart-legend-gray"></span>
                            <span className="lao-dong-chart-legend-name">
                                Khác
                            </span>
                            <span className="lao-dong-chart-legend-value">
                                2.106 (4,36%)
                            </span>
                        </div>
                    </div>

                </div>

                <button
                    className="lao-dong-chart-detail-button"
                    type="button"
                >
                    Xem báo cáo chi tiết <i className="fa-solid fa-arrow-right icon-next-detail"></i>
                </button>

            </div>

            {/* <!-- biểu đồ 2 --> */}
            <div className="lao-dong-chart-card lao-dong-chart-card-35">

                <div className="lao-dong-chart-header">
                    <h3 className="lao-dong-chart-title">
                        Cơ cấu lao động theo giới tính
                    </h3>
                </div>

                <div className="lao-dong-chart-content">

                    <div className="lao-dong-gender-chart">
                        <div className="lao-dong-gender-chart-center">
                            <span className="lao-dong-donut-chart-total-text">
                                Tổng số
                            </span>

                            <h3 className="lao-dong-donut-chart-total-number">
                                48.761
                            </h3>

                            <span className="lao-dong-donut-chart-total-unit">
                                người
                            </span>
                        </div>
                    </div>

                    <div className="lao-dong-chart-legend">
                        <div className="lao-dong-chart-legend-item">
                            <span className="lao-dong-chart-legend-color lao-dong-chart-legend-blue"></span>

                            <span className="lao-dong-chart-legend-name">
                                Nam
                            </span>

                            <span className="lao-dong-chart-legend-value">
                                28.341 (58,13%)
                            </span>
                        </div>

                        <div className="lao-dong-chart-legend-item">
                            <span className="lao-dong-chart-legend-color lao-dong-chart-legend-pink"></span>

                            <span className="lao-dong-chart-legend-name">
                                Nữ
                            </span>

                            <span className="lao-dong-chart-legend-value">
                                20.420 (41,87%)
                            </span>
                        </div>
                    </div>

                </div>

                <button
                    className="lao-dong-chart-detail-button"
                    type="button"
                >
                    Xem chi tiết <i className="fa-solid fa-arrow-right icon-next-detail"></i>
                </button>

            </div>

            {/* <!-- biểu đồ 3 --> */}
            <div className="lao-dong-chart-card lao-dong-chart-card-30">

                <div className="lao-dong-chart-header">
                    <h3 className="lao-dong-chart-title">
                        Cơ cấu lao động theo trình độ
                    </h3>
                </div>

                <div className="lao-dong-skill-chart">

                    <div className="lao-dong-skill-chart-item">
                        <span className="lao-dong-skill-chart-label">
                            Đại học trở lên
                        </span>

                        <div className="lao-dong-skill-chart-bar-wrap">
                            <div
                                className="lao-dong-skill-chart-bar lao-dong-skill-chart-bar-1"
                            ></div>
                        </div>

                        <span className="lao-dong-skill-chart-value">
                            8.215 (16,84%)
                        </span>
                    </div>

                    <div className="lao-dong-skill-chart-item">
                        <span className="lao-dong-skill-chart-label">
                            Cao đẳng, trung cấp
                        </span>

                        <div className="lao-dong-skill-chart-bar-wrap">
                            <div
                                className="lao-dong-skill-chart-bar lao-dong-skill-chart-bar-2"
                            ></div>
                        </div>

                        <span className="lao-dong-skill-chart-value">
                            12.643 (25,93%)
                        </span>
                    </div>

                    <div className="lao-dong-skill-chart-item">
                        <span className="lao-dong-skill-chart-label">
                            Sơ cấp, công nhân kỹ thuật
                        </span>

                        <div className="lao-dong-skill-chart-bar-wrap">
                            <div
                                className="lao-dong-skill-chart-bar lao-dong-skill-chart-bar-3"
                            ></div>
                        </div>

                        <span className="lao-dong-skill-chart-value">
                            18.572 (38,10%)
                        </span>
                    </div>

                    <div className="lao-dong-skill-chart-item">
                        <span className="lao-dong-skill-chart-label">
                            Lao động phổ thông
                        </span>

                        <div className="lao-dong-skill-chart-bar-wrap">
                            <div
                                className="lao-dong-skill-chart-bar lao-dong-skill-chart-bar-4"
                            ></div>
                        </div>

                        <span className="lao-dong-skill-chart-value">
                            9.331 (19,13%)
                        </span>
                    </div>

                    <div className="lao-dong-skill-chart-axis">
                        <span>0</span>
                        <span>10K</span>
                        <span>20K</span>
                        <span>30K</span>
                    </div>

                </div>

                <button
                    className="lao-dong-chart-detail-button"
                    type="button"
                >
                    Xem chi tiết <i className="fa-solid fa-arrow-right icon-next-detail"></i>
                </button>

            </div>

        </div>

        {/* <!-- bảng --> */}
        <div className="lao-dong-table-row">

            {/* <!-- bảng trái --> */}
            <div className="lao-dong-table-card">

                <div className="lao-dong-table-header">
                    <h3 className="lao-dong-table-title">
                        Thống kê lao động theo khu công nghiệp
                    </h3>

                    {/* <button
                        className="lao-dong-table-month-button"
                        type="button"
                    >
                        Tháng 05/2026
                    </button> */}
                    <input  className="lao-dong-table-month-button" 
                    placeholder='Tháng 05/2026' type='date'></input>

                </div>

                <table className="lao-dong-table">
                    <thead>
                        <tr>
                            <th>Khu công nghiệp</th>
                            <th>Lao động đang làm việc (người)</th>
                            <th>Tỷ lệ (%)</th>
                            <th>So với tháng trước</th>
                        </tr>
                    </thead>

                    <tbody>

                        <tr>
                            <td>KCN Biên Hòa</td>
                            <td>22.458</td>
                            <td>46,06%</td>
                            <td className="lao-dong-table-growth-up">
                                <i className="fa-solid fa-arrow-up icon-table-arr"></i>  2,35%
                            </td>
                        </tr>

                        <tr>
                            <td>KCN Bình Long</td>
                            <td>12.385</td>
                            <td>25,39%</td>
                            <td className="lao-dong-table-growth-up">
                                 <i className="fa-solid fa-arrow-up icon-table-arr"></i> 1,98%
                            </td>
                        </tr>

                        <tr>
                            <td>KCN Mỹ Thái</td>
                            <td>7.842</td>
                            <td>16,07%</td>
                            <td className="lao-dong-table-growth-up">
                                 <i className="fa-solid fa-arrow-up"></i> 2,76%
                            </td>
                        </tr>

                        <tr>
                            <td>KCN Thới Sơn</td>
                            <td>4.076</td>
                            <td>8,36%</td>
                            <td className="lao-dong-table-growth-down">
                                <i class="fa-solid fa-arrow-down icon-table-arr"></i> 0,45%
                            </td>
                        </tr>

                        <tr>
                            <td><strong>Tổng cộng</strong></td>
                            <td><strong>48.761</strong></td>
                            <td><strong>100%</strong></td>
                            <td className="lao-dong-table-growth-up">
                                <strong>
                                     <i className="fa-solid fa-arrow-up icon-table-arr"></i>
                                    2,18%</strong>
                            </td>
                        </tr>

                    </tbody>
                </table>

                <button
                    className="lao-dong-table-view-all"
                    type="button"
                >
                    Xem tất cả <i className="fa-solid fa-arrow-right icon-next-detail"></i>
                </button>

            </div>
{/* 
            <!-- bảng phải --> */}
            <div className="lao-dong-table-card">

                <div className="lao-dong-table-header">
                    <h3 className="lao-dong-table-title">
                        Danh sách doanh nghiệp sử dụng lao động
                    </h3>

                    <div className="lao-dong-table-search">
                        <input
                            className="lao-dong-table-search-input"
                            type="text"
                            placeholder="Tìm kiếm doanh nghiệp..."
                        />
                    </div>
                </div>

                <table className="lao-dong-table">
                    <thead>
                        <tr>
                            <th>STT</th>
                            <th>Tên doanh nghiệp</th>
                            <th>Khu công nghiệp</th>
                            <th>Lao động đang làm việc</th>
                            <th>So với tháng trước</th>
                        </tr>
                    </thead>

                    <tbody>

                        <tr>
                            <td>1</td>
                            <td>Công ty TNHH An Phát</td>
                            <td>KCN Bình Hòa</td>
                            <td>8.452</td>
                            <td className="lao-dong-table-growth-up">
                                <i className="fa-solid fa-arrow-up icon-table-arr"></i> 3,20%
                            </td>
                        </tr>

                        <tr>
                            <td>2</td>
                            <td>Công ty CP Cơ khí AG</td>
                            <td>KCN Bình Hòa</td>
                            <td>4.872</td>
                            <td className="lao-dong-table-growth-up">
                                <i className="fa-solid fa-arrow-up icon-table-arr"></i> 1,75%
                            </td>
                        </tr>

                        <tr>
                            <td>3</td>
                            <td>Công ty TNHH May Mặc ABC</td>
                            <td>KCN Bình Long</td>
                            <td>3.965</td>
                            <td className="lao-dong-table-growth-up">
                                <i className="fa-solid fa-arrow-up icon-table-arr"></i> 2,10%
                            </td>
                        </tr>

                        <tr>
                            <td>4</td>
                            <td>Công ty TNHH An Giang</td>
                            <td>KCN Bình Hòa</td>
                            <td>3.210</td>
                            <td className="lao-dong-table-growth-down">
                                <i class="fa-solid fa-arrow-down icon-table-arr"></i> 0,30%
                            </td>
                        </tr>

                        <tr>
                            <td>5</td>
                            <td>Công ty CP Điện tử AG</td>
                            <td>KCN Mỹ Thới</td>
                            <td>2.874</td>
                            <td className="lao-dong-table-growth-up">
                               <i className="fa-solid fa-arrow-up icon-table-arr"></i> 1,05%
                            </td>
                        </tr>

                    </tbody>
                </table>

                <button
                    className="lao-dong-table-view-all"
                    type="button"
                >
                    Xem tất cả <i className="fa-solid fa-arrow-right icon-next-detail"></i>
                </button>

            </div>

        </div>

        {/* <!-- tiện ích --> */}
        <div className="lao-dong-utility-section">

            <h3 className="lao-dong-utility-title">
                Tiện ích lao động
            </h3>

            <div className="lao-dong-utility-grid">

                <div className="lao-dong-utility-card">
                    <div className="lao-dong-utility-icon lao-dong-utility-icon-purple">
                        <i className="fa-solid fa-user-plus"></i>
                    </div>
                    <div>
                        
                    <h4 className="lao-dong-utility-card-title">
                        Nhu cầu tuyển dụng
                    </h4>

                    <p className="lao-dong-utility-card-text">
                        Quản lý nhu cầu tuyển dụng của doanh nghiệp
                    </p>
                    </div>
                </div>

                <div className="lao-dong-utility-card">
                    <div className="lao-dong-utility-icon lao-dong-utility-icon-blue">
                        <i className="fa-solid fa-graduation-cap"></i>
                    </div>

                    <div>
                        <h4 className="lao-dong-utility-card-title">
                        Đào tạo, bồi dưỡng
                    </h4>

                    <p className="lao-dong-utility-card-text">
                        Quản lý chương trình đào tạo, bồi dưỡng nghề
                    </p>
                    </div>
                </div>

                <div className="lao-dong-utility-card">
                    <div className="lao-dong-utility-icon lao-dong-utility-icon-green">
                       <i className="fa-solid fa-heart-circle-check"></i>
                    </div>

                   <div>
                     <h4 className="lao-dong-utility-card-title">
                        An toàn lao động
                    </h4>

                    <p className="lao-dong-utility-card-text">
                        Theo dõi, báo cáo an toàn lao động
                    </p>
                   </div>
                </div>

                <div className="lao-dong-utility-card">
                    <div className="lao-dong-utility-icon lao-dong-utility-icon-red">
                        <i className="fa-solid fa-heart"></i>
                    </div>

                    <div>
                        <h4 className="lao-dong-utility-card-title">
                        Bảo hiểm, phúc lợi
                    </h4>

                    <p className="lao-dong-utility-card-text">
                        Quản lý BHXH, BHYT và phúc lợi
                    </p>
                    </div>
                </div>

                <div className="lao-dong-utility-card">
                    <div className="lao-dong-utility-icon lao-dong-utility-icon-yellow">
                        <i className="fa-solid fa-chart-column"></i>
                    </div>

                   <div>
                     <h4 className="lao-dong-utility-card-title">
                        Báo cáo thống kê
                    </h4>

                    <p className="lao-dong-utility-card-text">
                        Báo cáo, thống kê lao động định kỳ
                    </p>
                   </div>
                </div>

                <div className="lao-dong-utility-card">
                    <div className="lao-dong-utility-icon lao-dong-utility-icon-indigo">
                        <i className="fa-solid fa-earth-asia"></i>
                    </div>

                    <div>
                        <h4 className="lao-dong-utility-card-title">
                        Xuất khẩu lao động
                    </h4>

                    <p className="lao-dong-utility-card-text">
                        Quản lý lao động làm việc ở nước ngoài
                    </p>
                    </div>
                </div>

            </div>

        </div>

    </div>

        );
    }


export default LaoDong;